import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/data.service';
import { PropertyService } from '../shared/property.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

declare var $: any;
declare var PhotoSwipe: any;

@Component({
    selector: 'sold-image-carousel',
    moduleId: module.id,
    templateUrl: './image-carousel.component.html',
    styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit {

    propertyData: any[] = [];
    errorMessage = null;
    gallery: any;
    PhotoSwipe: any;
    threeImage: boolean = false;

    constructor(
        private _dataService: DataService,
        private _propertyService: PropertyService,
        private _activatedRoute: ActivatedRoute) { }

    ngOnInit() {

        this._activatedRoute.queryParams.subscribe((params: Params) => {
            if (params['propRef'] !== undefined) {
                this._dataService.getPropertyData(params['propRef'])
                .subscribe(propData => {
                    this.propertyData = propData,
                    this.threeImage = this._propertyService.cTest;
                
                },
                error => this.errorMessage = <any>error);
            }
          });

        // this._dataService.getPropertyData('hrt018707276')
        //     .subscribe(propData => this.propertyData = propData,
        //     error => this.errorMessage = <any>error);

        $.getScript('../assets/js/swiper.js');


        

    }

    openImage(imageID) {

        let pswpElement: any;
        let imageGallery: any[];
        let PhotoSwipeUI_Default: any;
        let options: any;

        pswpElement = document.querySelectorAll('.pswp')[0];

        imageGallery = [];
        for (const i of this.propertyData) {
            let img: any;
            img = {
                src: i.ImageURL,
                w: 1500,
                h: 1000
            };
            imageGallery.push(img);
        }

        options = {
            index: imageID
        };

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, imageGallery, options);
            this.gallery.init();
        }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/imageCarousel/image-carousel.component.ts